import { COOKIE_MONETATE_ID } from 'constants/cookies';
import { PAGE_SET_REQUEST_COOKIES } from 'redux/modules/page/actions/types';

export const setMonetateRequestCookie = (monetateId: string) => ({
  type: PAGE_SET_REQUEST_COOKIES,
  payload: `${COOKIE_MONETATE_ID}=${monetateId}`,
});
